export const layout = {
  state: {
    layoutBinding: {}
  },
  mutations: {
    setLayoutBinding: (state, payload) => {
      state.layoutBinding = payload
    }
  },
  actions: {
    setLayoutBinding: (context, binding) => {
      context.commit('setLayoutBinding', binding)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/layout.js